import { useState, type ReactNode } from "react";
import { Dialog } from "@/components/modals";
import "@/styles/student.css";
import "./StudentPreviewDialog.css";

export default function StudentPreviewDialog({
  open,
  onClose,
  title = "Student preview",
  frame = "reading",
  children,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  /** `page` is the full activity (title, chips, parts, questions). */
  frame?: "reading" | "page";
  children: ReactNode;
}) {
  const [viewport, setViewport] = useState<"desktop" | "mobile">("desktop");

  return (
    <Dialog
      open={open}
      title={title}
      subtitle="How this looks to a learner"
      width={viewport === "mobile" ? "26rem" : "42rem"}
      maxHeight="80vh"
      onClose={onClose}
      headerActions={
        <div className="al-cb-preview-tabs" role="tablist" aria-label="Preview size">
          <button
            type="button"
            role="tab"
            aria-selected={viewport === "desktop"}
            className={`al-cb-preview-tab${viewport === "desktop" ? " al-cb-preview-tab--on" : ""}`}
            onClick={() => setViewport("desktop")}
          >
            Desktop
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={viewport === "mobile"}
            className={`al-cb-preview-tab${viewport === "mobile" ? " al-cb-preview-tab--on" : ""}`}
            onClick={() => setViewport("mobile")}
          >
            Mobile
          </button>
        </div>
      }
    >
      <div
        className={`al-cb-preview-stage${viewport === "mobile" ? " al-cb-preview-stage--mobile" : ""}${
          frame === "page" ? " al-cb-preview-stage--page" : ""
        }`}
      >
        <div className="acuity-student acuity-student--preview">
          {frame === "reading" ? <div className="student-reading">{children}</div> : children}
        </div>
      </div>
    </Dialog>
  );
}
